import { inject, Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { SHARED_ENVIRONMENT } from '../environment/shared-environment.token';
import { SeverityLevel } from './error-severity';

export { SeverityLevel } from './error-severity';

@Injectable({
    providedIn: 'root'
})
export class AppInsightsService {
    appInsights: ApplicationInsights | undefined;
    private readonly sharedEnv = inject(SHARED_ENVIRONMENT);

    constructor() {
        if (this.sharedEnv.instrumentationKey) {
            this.appInsights = new ApplicationInsights({
                config: {
                    instrumentationKey: this.sharedEnv.instrumentationKey,
                    enableAutoRouteTracking: true // option to log all route changes
                }
            });
            this.appInsights.loadAppInsights();
        }
    }

    // methods to be used to log additional events as needed
    logPageView(name?: string, url?: string) { // option to call manually
        if (!this.appInsights) return;
        this.appInsights.trackPageView({
            name: name,
            uri: url
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    logEvent(name: string, properties?: { [key: string]: any }) {
        if (!this.appInsights) return;
        this.appInsights.trackEvent({ name: name }, properties);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    logMetric(name: string, average: number, properties?: { [key: string]: any }) {
        if (!this.appInsights) return;
        this.appInsights.trackMetric({ name: name, average: average }, properties);
    }

    
    log(exception: Error, severityLevel?: SeverityLevel) {
        if (!this.appInsights) return;
        this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    logTrace(message: string, properties?: { [key: string]: any }) {
        if (!this.appInsights) return;
        this.appInsights.trackTrace({ message: message }, properties);
    }
}
